module.exports = state => `
  <nav>
    <a href="https://github.com/ZhouHansen">github </a>
    <a href="https://twitter.com/Zhouhancheng">twitter </a>
    
    <a class="cta" href="/">Blog </a>
  </nav>
  ${!state.isArticle ? `
    <div class='header-wrap'>
      <img src='./assets/avatar.png' />
      <h1>Zhou Hancheng</h1>
      <p>A poor <mark>freelancer</mark></p>
    </div>
  ` : ``}
`